import { render, staticRenderFns } from "./CartSummaryForm.vue?vue&type=template&id=12269999&scoped=true&"
import script from "./CartSummaryForm.vue?vue&type=script&lang=js&"
export * from "./CartSummaryForm.vue?vue&type=script&lang=js&"
import style0 from "./CartSummaryForm.vue?vue&type=style&index=0&id=12269999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12269999",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/cart_summary_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FCartSummaryForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports